import React from 'react';
import Layout from '../../components/Layout';
import Shop from './Shop';
import {
  getProducts,
  updateFiltersFromParams,
  getProductPriceInterval,
} from '../../actions/shop';
import { getBasket } from '../../actions/basket';
import {
  clearUserStorage,
  getSalesChannelId,
  getSalesChannelBasketId,
} from '../../helpers/userStorage';
import { getPagePresentationKeys } from '../../actions/page';
import { PER_PAGE, SALES_CHANNELS } from '../../constants';
import { getShopParams } from '../../helpers';
import { getCountryPresentations, setSalesChannel } from '../../actions/config';

const pageName = 'shop';

const getCurrentBrand = (paramBrandIds = [], brands = []) => {
  if (paramBrandIds.length === 1) {
    return brands.find(({ id }) => id === paramBrandIds[0]) || {};
  }
  return {};
};

async function action({ store, query }) {
  const {
    config: {
      menu: { brands },
    },
    shop: { currentPage = 1 },
    intl: { countryCode, locale },
  } = store.getState();
  let salesChannelId = getSalesChannelId();

  const { basketId } =
    getSalesChannelBasketId({
      salesChannelId,
      countryCode,
    }) || {};
  const { vouchers } = await store.dispatch(getBasket(basketId));
  if (
    salesChannelId &&
    salesChannelId !== SALES_CHANNELS.B2B &&
    salesChannelId !== SALES_CHANNELS.B2C &&
    !vouchers?.length
  ) {
    clearUserStorage();
    salesChannelId = SALES_CHANNELS.B2C;
    await store.dispatch(setSalesChannel(salesChannelId));
  }
  const params = getShopParams(query);
  const {
    byName: {
      [pageName]: { pageTitle, pageDescription },
    },
  } = await store.dispatch(
    getPagePresentationKeys({
      pageName,
      salesChannelIdParam: salesChannelId,
    }),
  );

  await store.dispatch(getCountryPresentations({ countryCode, locale }));

  await store.dispatch(updateFiltersFromParams(params));
  const {
    min: minFromPriceIntervalQuery,
    max: maxFromPriceIntervalQuery,
  } = await store.dispatch(getProductPriceInterval());

  let paramsForGetProductsQuery;
  let minForGetProductsQuery;
  let maxForGetProductsQuery;

  const careAboutPriceInterval =
    params.filters.type.length === 1 &&
    params.filters.type[0] === 'physicalProduct';

  if (!careAboutPriceInterval) {
    const { min, max, ...paramsWithoutMinMax } = params;
    paramsForGetProductsQuery = paramsWithoutMinMax;
    minForGetProductsQuery = 1;
    maxForGetProductsQuery = 900000;
  } else {
    paramsForGetProductsQuery = params;
    minForGetProductsQuery =
      params.min != null
        ? Math.floor(parseInt(params.min, 10))
        : minFromPriceIntervalQuery;
    maxForGetProductsQuery =
      params.max != null
        ? Math.ceil(parseInt(params.max, 10))
        : maxFromPriceIntervalQuery;
  }

  await store.dispatch(
    getProducts({
      page: 1,
      perPage: currentPage * PER_PAGE,
      params: {
        ...paramsForGetProductsQuery,
        min: minForGetProductsQuery,
        max: maxForGetProductsQuery,
      },
    }),
  );

  const {
    filters: { brand: paramBrandIds },
  } = params;

  const { brandMetaTitle, brandMetaDescription } = getCurrentBrand(
    paramBrandIds,
    brands,
  );

  return {
    chunks: ['shop'],
    title: brandMetaTitle || pageTitle || 'Shop',
    description: brandMetaDescription || pageDescription,
    component: (
      <Layout footer={false} footerBar redeemOverview>
        <Shop />
      </Layout>
    ),
    // do not hydrate html on client side, instead overwrite with new client render
    // for now this is a fix for getting mixed up html after channel changes on client side
    forceRender: true,
  };
}

export default action;
